export default __webpack_public_path__ + "static/media/addon5.d3eb3416.webp";